import { useTranslation } from "react-i18next";
import ModalProps from "@ltypes/modalProps";
import Modal from "@components/modals/Modal/Modal";
import Button from "@components/forms/Button/Button";
import { ConfirmationOptionsType } from "@contexts/ConfirmationContext";
import './ConfirmationModal.scss';

type ConfirmationModalProps = {
    title: string,
    yesText?: string,
    noText?: string,
    options?: ConfirmationOptionsType,
    onAccept: () => void,
} & ModalProps;

function ConfirmationModal(props: ConfirmationModalProps) {
    const { t } = useTranslation();

    const handleAccept = () => {
        props.onHide();
        props.onAccept();
    };

    return (
        <Modal className="modal-confirmation" visible={props.visible} onHide={props.onHide}>
            <h2 className="text-center">{props.title}</h2>
            {props.options && props.options.description && (
                <h3>{props.options.description}</h3>
            )}
            <div className="row">
                <div className="col-6">
                    <Button filled onClick={props.onHide} className="secondary">{props.noText ?? t('text.no')}</Button>
                </div>
                <div className="col-6">
                    <Button filled onClick={handleAccept}>{props.yesText ?? t('text.yes')}</Button>
                </div>
            </div>
        </Modal>
    );
}

export default ConfirmationModal;
